/* RESPONSIBLE TEAM: team-actions */
export default {
  NO_RISK: 0,
  LOW_RISK: 1,
  MEDIUM_RISK: 2,
  HIGH_RISK: 3,
};
